import React, { memo } from "react";

import { LexerOptions, lexizeText } from "@app/component/Lexer/lexizeText";

interface LexerProps extends LexerOptions {
  children: string;
}

const Lexer = ({ children, ...options }: LexerProps) => (
  <React.Fragment>{lexizeText(children, options)}</React.Fragment>
);

export default memo(Lexer);
